import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button, LinkLang } from 'ui';
import { ReactComponent as ChevronRightSvg } from 'assets/icons/chevron-right.svg';
var ActionProfile = function () {
    var t = useTranslation().t;
    return (_jsx(LinkLang, { to: 'personal', children: _jsx(Button, { size: 'small', variant: 'secondary', iconRight: ChevronRightSvg, iconSize: 16, style: { backgroundColor: '#27272a' }, children: t('common:edit') }) }));
};
export default ActionProfile;
